import { gql } from '@apollo/client';

export const ALL_INSTITUTIONS_FOR_SELECT_INPUT = gql`
  query AllInstitutionsForSelectInput($input: FilterInstitutions!) {
    institutions: getInstitutions(input: $input) {
      aggregate {
        count
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          name
        }
      }
    }
  }
`;
